import { Component, OnInit } from '@angular/core';
import { ClassroomService,MasterService } from '../../services/index';
import { HttpClient } from '@angular/common/http';
import { AppGlobals } from '../../shared/app.global';
import {NgbModal, ModalDismissReasons,NgbModalOptions,NgbModalRef} from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-assignment',
  templateUrl: './assignment.component.html',
  styleUrls: ['./assignment.component.scss'],
  providers:[ClassroomService,MasterService]
})
export class AssignmentComponent implements OnInit {

  closeResult: string;
  modalOptions:NgbModalOptions;
  private modalRef: NgbModalRef;
 
  
  cnid:any;
  
  arrftype=[{name:'Url'},{name:'File'}];
  ftype:any;
  fpath:any;
  fnm:any;
  arrstudoc:any=[];
  fileToUpload: File = null;

  fData: FormData = new FormData;
  notetype=[{name:'Homework'},{name:'Activity'},{name:'Information'}];
  objfilt:any={};
    objsch:any={};
    arrasch:any=[];
    sections:any=[];
    classes:any=[];
    arrsubjects:any=[];
    arrschnote:any=[];
    arrschnoteda:any=[];
    arrrepdata:any=[];
    arrcourse:any=[];
    fmodel:any={clid:'0',secid:'0',subid:'0',prid:'0'};

  constructor(private http: HttpClient, private cservice: ClassroomService,private mservice:MasterService,private modalService: NgbModal,private apglobal:AppGlobals) { }

  ngOnInit(): void {
    this.getcourselist();
  }

 
  masclass() {
    this.mservice.classmasterrolewise(0,this.fmodel.crid,0,'class')
        .subscribe(
        resultArray => {
            console.log('getdashcounts', resultArray);
            this.classes = resultArray;
            this.fmodel.clid=resultArray[0].clid;
            this.objsch.clid=resultArray[0].clid;
            this.massection();
            
           
        },
        error => console.log("Error :: " + error)
        )
  }

 
  massection() {
    this.mservice.sectionsrolewise(0,this.fmodel.crid,this.fmodel.clid,'section')
        .subscribe(
        resultArray => {
            console.log('getdashcounts', resultArray);
            this.sections = resultArray;
            this.fmodel.secid=resultArray[0].scid;
            this.objsch.secid=resultArray[0].scid;
            this.subjects();
        },
        error => console.log("Error :: " + error)
        )
  }

  getcourselist() {
    this.mservice.mascourse()
        .subscribe(
        resultArray => {
            console.log('class-result', resultArray);
            this.arrcourse = resultArray;
            this.fmodel.crid=resultArray[0].crid;
            this.objsch.crid=resultArray[0].crid;
            this.masclass(); 

        },
        error => console.log("Error :: " + error)
        )
  }
  
  subjects() {
    this.mservice.subjectsrolewise(0,0,this.fmodel.clid,'asaa',this.fmodel.crid)
          .subscribe(
          resultArray => {
              console.log('getdashcounts', resultArray);
              this.arrsubjects = resultArray;
              this.fmodel.subid=resultArray[0].suid;
             // this.objsch.subid=resultArray[0].suid;
              this.Bindtable() ;
          },
          error => console.log("Error :: " + error)
          )
    }

    subjects2() {
      this.mservice.subjectsrolewise(0,0,this.objsch.clid,'asaa', this.objsch.crid)
          .subscribe(
          resultArray => {
              console.log('getdashcounts', resultArray);
              this.arrsubjects = resultArray;
             // this.fmodel.subid=resultArray[0].suid;
              this.objsch.suid=resultArray[0].suid;
             // this.Bindtable() ;
          },
          error => console.log("Error :: " + error)
          )
    }

    onclasschange()
    {
      this.massection();
      this.subjects();

    }

    onclscrschange()
    {
      this.massection();
      this.subjects2();

    }

    Bindtable() {
      debugger
      
      
      this.cservice.getcomclnote(this.fmodel.clid,this.fmodel.secid,this.fmodel.subid,this.fmodel.crid)
          .subscribe(resultArray => {
             console.log('ret-select', resultArray);
              this.arrschnote = resultArray;
              //alert (resultArray.message);

          }, error =>
              alert('error in connection')
          );
      
  }


  bindnoteda(cnid) {
    debugger
    
    
    this.cservice.getcomclnoteda(cnid)
        .subscribe(resultArray => {
           console.log('ret-select', resultArray);
            this.arrschnoteda = resultArray;
            //alert (resultArray.message);

        }, error =>
            alert('error in connection')
        );
    
}

delclnote(cnid) {
  debugger
  if (confirm('Are you sure you want to delete'))
  {
  this.cservice.delclnote(cnid)
      .subscribe(resultArray => {
        // console.log('ret-select', resultArray);
          //this.arrschnoteda = resultArray;
          alert (resultArray.message);
this.Bindtable();
      }, error =>
          alert('error in connection')
      );
    }
}


openlink(url){
  

  window.open(url,'','_blank');
}
SaveDetails() {
    
  console.log('save-model', this.objsch);
  var dbnm='';
  

  this.cservice.savecomclnote(this.objsch)
      .subscribe(resultArray => {
          console.log('ret-save', resultArray);
          
          alert (resultArray.message);
          if(resultArray.status=='success')
          {
            let localmodref=this.modalRef;
            localmodref.close();
           // this.Getsel_sp_massubgp();
           this.Bindtable();
          }
          

      }, error =>
          alert('error in connection')
      );
 // this.closeAddExpenseModal.nativeElement.click();

}


    opensubject(content,objdata,cmd) {
      debugger

      console.log(objdata);
      if(cmd=='insert')
      {
        this.objsch={};
       
        
        //console.log('date',this.sservice.getdatetoday().toString())
        this.objsch.cntype='Homework';
        this.objsch.cnid='0';
        this.objsch.cncontent='';
        this.objsch.cndt=this.apglobal.getdatetoday();
        this.objsch.cnduedt=this.apglobal.getdatetoday();
        this.objsch.clid=this.fmodel.clid;
        this.objsch.suid=this.fmodel.subid;
        this.objsch.scid=this.fmodel.secid;
        this.objsch.crid=this.fmodel.crid;
        this.objsch.oprtype='insert';
       
      }
    
      else if(cmd=='update')
      {
  debugger
        
        this.objsch=objdata;
        
        this.objsch.stuid=objdata.stuid;
        this.objsch.oprtype='update';
      }
      
      this.modalOptions = {
        backdrop:'static',
        backdropClass:'customBackdrop',
        size:'md'
        
       
      }
      this.modalRef=this.modalService.open(content,this.modalOptions);
      
      this.modalRef.result.then((result) => {
     
           
        }, (reason) => {
            
        });
    }


    openinfo(content,nfid)
{
  //this.getstudentdocs(bkid);
//this.masgeneral('Student Docs');
this.bindnoteda(nfid);
  this.cnid=nfid;
  this.fpath='';
  this.ftype="Url";
  this.modalOptions = {
    backdrop:'static',
    backdropClass:'customBackdrop',
    size:'lg'
   }
  this.modalRef=this.modalService.open(content,this.modalOptions);
  
  this.modalRef.result.then((result) => {
 
       // this.Asmtdetls(asid);
        this.closeResult = `Closed with: ${result}`;
    }, (reason) => {
       // this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
    });
}

upload(files: FileList) {
  debugger;
  this.fileToUpload = files.item(0);

  this.fData.append("nfid", this.cnid.toString());
  this.fData.append("fpath", this.fpath.toString());
  this.fData.append("ftype", this.ftype.toString());
  //this.fData.append("docpurpose", "Studentphoto");

  // this.SService.uploadFile(fData).subscribe(
  //     response => this.handleResponse(response),
  //     error => this.handleError(error)
  // )
}

fileupload()
{
debugger

console.log('file data',JSON.stringify(this.fileToUpload));

this.cservice.uploadcomclnoteda(this.fileToUpload,this.cnid,this.fpath,this.ftype,this.fnm)
.subscribe(fresult => {
   // console.log('ret',JSON.stringify(fresult));
    alert (fresult.message);
    if(fresult.status=='Success')
{
// let localmodref=this.modalRef;
// localmodref.close();
//this.Refreshsummary();
this.fileToUpload=null;
this.fpath='';
this.fnm="";

this.bindnoteda(this.cnid);
}
    
}, error => 
alert('error in connection')

);



}


delnoteda(stuid) {
  if(confirm("Are you sure you wan't to delete?"))
  {
  this.cservice.delnoteda(stuid)
      .subscribe(
      resultArray => {
          console.log('arrmtongue', resultArray);
          //this.arrstudoc = resultArray;
          alert(resultArray.message);
          this.bindnoteda(this.cnid);
         
      },
      error => console.log("Error :: " + error)
      )
    }
}

}
